module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0082.jpg?v=9f3ca943";